import React from "react";
import { Link } from "react-router-dom";
import "./EmptyWidget.css";

export const EmptyWidget = ({ text, ctaText, buttonText, buttinLink }) => {
  return (
    <div className="EmptyWidget border-dark flex">
      <div className="nodata-text">{text}</div>
      <div className="cta-text">{ctaText}</div>
      <Link to={buttinLink} exact="true" className="default_button">
        {buttonText}
      </Link>
    </div>
  );
};
